import React from 'react';
import { Check } from 'lucide-react';
export function TargetAudience() {
  return <section className="py-20 bg-white" data-id="element-186">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-187">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-188">
          {/* Target Audience */}
          <div data-id="element-189">
            <h2 className="text-3xl md:text-4xl font-bold text-[#0F172A] mb-8 border-l-8 border-[#1B5E20] pl-6" data-id="element-190">
              ¿Para quién es este MegaPack?
            </h2>
            <ul className="space-y-4" data-id="element-191">
              {['Docentes de Educación Física', 'Profesores con poco tiempo para planificar', 'Quienes quieren clases ordenadas y profesionales', 'Quienes están cansados de improvisar', 'Quienes quieren enseñar mejor sin desgastarse'].map((item, i) => <li key={i} className="flex items-center gap-3 p-4 bg-gray-50 rounded-lg border border-gray-100 shadow-sm" data-id="element-192">
                  <div className="bg-[#1B5E20] rounded-full p-1" data-id="element-193">
                    <Check className="w-4 h-4 text-white" data-id="element-194" />
                  </div>
                  <span className="text-lg font-medium text-gray-800" data-id="element-195">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Transformation */}
          <div className="bg-[#1B5E20] text-white rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-196">
            <div className="absolute top-0 right-0 w-full h-full bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10" data-id="element-197"></div>

            <div className="relative z-10" data-id="element-198">
              <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-199">
                ¿Qué cambia desde el primer día?
              </h2>

              <ul className="space-y-4 mb-10" data-id="element-200">
                {['Sabés qué clase dar', 'Tenés actividades claras', 'Evaluás con seguridad', 'Ahorrás horas de planificación', 'Sentís control y tranquilidad'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-201">
                    <Check className="w-6 h-6 text-[#F59E0B]" data-id="element-202" />
                    <span className="text-xl font-medium" data-id="element-203">{item}</span>
                  </li>)}
              </ul>

              <div className="bg-white/10 rounded-xl p-6 backdrop-blur-sm border border-white/20" data-id="element-204">
                <p className="text-lg font-semibold text-[#F59E0B] uppercase tracking-wider mb-2" data-id="element-205">
                  No es solo material
                </p>
                <p className="text-2xl font-bold mb-4" data-id="element-206">
                  Es alivio mental y orden profesional
                </p>
                <p className="text-gray-200 italic" data-id="element-207">
                  "Cuando tenés todo listo: das mejores clases, trabajás con más
                  seguridad y volvés a disfrutar enseñar."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}